import React, { FC } from "react";
import { useSelector } from "react-redux";

import Tooltip from "@/components/ui/tooltip";
import { RootState } from "@/store";

import { Button } from "equator-design-system";
import { twMerge } from "tailwind-merge";

import { MenuItemType } from ".";

type Props = {
  index: number;
  menuItem: MenuItemType;
  isExpand: boolean;
};

const delayClasses: Record<number, string> = {
  0: "delay-300",
  1: "delay-400",
  2: "delay-500",
  3: "delay-600",
  4: "delay-700"
};

const NavItem: FC<Props> = ({ index, menuItem, isExpand }) => {
  const { sideBarMenuTypePopupDisplay } = useSelector(
    (state: RootState) => state.ui
  );
  const isActive =
    (menuItem.type && menuItem.type === sideBarMenuTypePopupDisplay) ||
    menuItem?.isActive;

  const handleClickMenu = () => {
    menuItem.onClick();
  };

  return (
    <Tooltip
      disable={isExpand}
      content={menuItem.name}
      position="right"
      key={menuItem.name}
    >
      <Button
        className={twMerge(
          delayClasses[index % 5],
          "group flex items-center h-[32px] duration-500 text-sm gap-4 font-medium btn-default p-0",
          "!border-none rounded-md hover:bg-teal-50",
          isExpand ? "w-[231px] justify-start bg-black pl-1.5" : "w-[32px]",
          isActive && "!bg-teal-50"
        )}
        onClick={handleClickMenu}
      >
        {menuItem.icon &&
          React.cloneElement(menuItem.icon as React.ReactElement, {
            className: twMerge(
              (menuItem.icon as React.ReactElement).props.className,
              isActive ? "fill-teal-500" : "fill-dim-gray",
              "group-hover:fill-teal-500"
            )
          })}
        <span
          className={twMerge(
            "whitespace-pre text-sm font-medium",
            !isExpand && "opacity-0 translate-x-28 overflow-hidden hidden",
            isActive && "text-black font-bold"
          )}
        >
          {menuItem.name}
        </span>
      </Button>
    </Tooltip>
  );
};

export default NavItem;
